<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="选择时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetStaticData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="科目" prop="name" align="center" />
        <el-table-column label="销售总额" prop="L1" align="center" />
        <el-table-column label="销售总额（不含体验）" prop="L2" align="center" />
        <el-table-column label="体验人数" prop="L3" align="center" />
        <el-table-column label="体验金额" prop="L4" align="center" />
        <el-table-column label="新签人数" prop="L5" align="center" />
        <el-table-column label="新签金额" prop="L6" align="center" />
        <el-table-column label="续费人数" prop="L7" align="center" />
        <el-table-column label="续费金额" prop="L8" align="center" />
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetStaticData" />
    </div>

  </div>

</template>
<script>

// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'
var moment = require('moment')

export default {
  name: 'TyyDoubleTestRecord',
  components: {

  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        begin_time: '',
        end_time: '',
        total: 0,
        time: ''
      }
    }
  },
  created() {
    this.listQuery.time = [moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    this.listQuery.begin_time = this.listQuery.time[0]
    this.listQuery.end_time = this.listQuery.time[1]
    this.fnGetStaticData()
  },
  methods: {
    fnGetStaticData: function() {
      this.$http.tyyRevenueStatistic(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
